import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductCategory } from '@warema/shared/company-search/models';
import { ProductCategoriesConnectorService } from '@warema/shared/connector-services';
import { map, exhaustMap } from 'rxjs/operators';
import * as ProductCategoryActions from './product-category.actions';

@Injectable({
    providedIn: 'root',
})
export class ProductCategoryEffects {
    private readonly _actions$ = inject(Actions);
    private readonly _productCategoryConnectorService = inject(ProductCategoriesConnectorService);

    public loadProductCategories$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(ProductCategoryActions.LoadProductCategories),
            exhaustMap(() =>
                this._productCategoryConnectorService.get().pipe(
                    map(dtoCategories =>
                        dtoCategories.map((pc): ProductCategory => ({
                            id: pc.id,
                            name: pc.name,
                            productCategories: pc.productCategories.map(spc => ({
                                id: spc.id,
                                name: spc.name,
                                selected: false,
                            })),
                        })),
                    ),
                    map(productCategories => {
                        productCategories.forEach(x => (x.id = x.id / 1000 - 1));
                        return ProductCategoryActions.ProductCategoriesLoaded({ productCategories });
                    }),
                ),
            ),
        );
    });
}
